module.exports = __webpack_public_path__ + "img/W-SDR-13.5.247509a3.jpg";